import { errorMessage } from 'modules/Error'
import { apiGetNotificationsToken } from '@/api/messages.api'
import FB from 'firebase'

export const Messages = {
  state: {
    messageProjects: [],
    messageToken: null
  },
  mutations: {
    setMessageProjects (state, payload) {
      state.messageProjects = [...payload]
    },
    
    setMessageToken (state, payload) {
      state.messageToken = payload
    }
  },
  actions: {
    async initMessages ({commit, getters}) {
      if (!getters.getUser.role || !['admin', 'projectManager', 'designer'].includes(getters.getUser.role)) return false

      const [err, data] = await apiGetNotificationsToken()
      if (err) return errorMessage(err, 'Unable to get messages token!')
      commit('setMessageToken', data)
      try {
        FB.initializeApp(getters.getMessageToken)
        await FB.auth().signInWithCustomToken(getters.getMessageToken.customToken)
        const messageDB = FB.database().ref(`/per-user-notifications/${getters.getUser.id}`)
        messageDB.on("value", snapshot => {
          commit('setMessageProjects', [])
          const projects = []
          const val = snapshot.val()
          if (!val) return projects

          Object.keys(val).forEach(projectId => {
            const project = { id: projectId, name: null, messages: [] }
            Object.keys(val[projectId]).forEach(messageId => {
              const message = {...val[projectId][messageId]}
              if (!project.name && message.pn) project.name = message.pn
              project.messages.push({
                id: messageId,
                senderName: message.sn,
                text: message.txt,
                timestamp: message.ts,
                link: message.ln,
                type: message.t
              })
            })
            projects.push(project)
          })
          commit('setMessageProjects', projects)
        })

      } catch (err) {
        err.message
          ? errorMessage(err, `Error: ${err.message}`)
          : errorMessage(err, 'Unable to get messages from Firebase!')
      }
    },

    clearMessages ({commit, dispatch}) {
      return commit('setMessageProjects', [])
    }
  },
  getters: {
    getMessageProjects (state) {
      return state.messageProjects
    },

    getMessagesCount (state) {
      let count = 0
      state.messageProjects.forEach(project => {
        count = count + project.messages.length
      })
      return count
    },

    getMessageToken (state) {
      return state.messageToken
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/Messages.js